import { getTourAttributes } from "@common/contexts/Tour";
import Icon from "@common/controls/Icon/component";
import { Common } from "@common/types";
import { isArray } from "lodash";
import React from "react";
import { type SelectHeading } from "../Base/component";

type ComponentPropsBase = {
  heading?: SelectHeading | SelectHeading[];
};

export type WithAddHOCBaseProps = {
  addTitle: string;
  addTourStep?: string;
  onAddClick: () => void;
};

const Header = (props: { tourStep?: string; addTitle: string }) => {
  return (
    <div className="test" {...getTourAttributes({ step: props.tourStep })}>
      <Icon icon={Common.IconType.Add} /> <span>{props.addTitle}</span>
    </div>
  );
};
const withAddHOC =
  <TProps extends ComponentPropsBase>(
    Component: React.ComponentType<TProps>
  ): React.FunctionComponent<TProps & WithAddHOCBaseProps> =>
  ({ addTitle, onAddClick, ...props }: TProps & WithAddHOCBaseProps) => {
    const heading = React.useMemo((): SelectHeading[] => {
      const heading = props.heading
        ? isArray(props.heading)
          ? (props.heading.slice() as SelectHeading[])
          : ([props.heading] as SelectHeading[])
        : [];
      heading.push({
        content: <Header addTitle={addTitle} tourStep={props.addTourStep} />,
        isSearch: false,
        isToggle: true,
        onClick: onAddClick
      });
      return heading;
    }, [addTitle, props.heading, onAddClick, props.heading, props.addTourStep]);

    return <Component {...(props as any)} heading={heading} />;
  };

export default withAddHOC;
